import React, { useEffect, useRef, useState } from 'react'
import styles from './index.module.less'
import { Drawer, Message, Modal } from '@arco-design/web-react'

import { GetQueryValue, removeEmpty } from '@/utils/common'
import { useDispatch, useSelector } from 'react-redux'
import { GlobalState } from '@/store'
import Markdown from '@/components/Markdown'
import { useHistory } from 'react-router-dom'
import BorderBtn from '@/components/BorderBtn'
import {
  IconClosure,
  IconEdit,
  IconMoreEdits,
} from '@arco-iconbox/react-aidb-v2'
import Tags from '@/components/DocCardItem/Tags'

const ShowQuickDrawer = (props) => {
  const detailData = useSelector((state: GlobalState) => state.detailData)
  const showQuick = useSelector((state: GlobalState) => state.showQuick)
  const tagsList = useSelector((state: GlobalState) => state.tagsList)
  const theme = useSelector((state: GlobalState) => state.theme)

  const dispatch = useDispatch()
  const history = useHistory()
  const handleCancel = () => {
    dispatch({
      type: 'update-showQuick',
      payload: { showQuick: false },
    })
  }

  const goDetail = () => {
    const urlQuery = removeEmpty({
      filePath: GetQueryValue('filePath') ? GetQueryValue('filePath') : '',
      uuid: detailData.uuid,
      folderUuid: GetQueryValue('uuid') ? GetQueryValue('uuid') : '',
      title: detailData.title,
      from: location.pathname.substring(1),
    }) as any
    history.push({
      pathname: '/documentEdit',
      search: '?' + new URLSearchParams(urlQuery).toString(),
    })
    handleCancel()
  }
  return (
    <Drawer
      className={`${styles['show-quick-drawer']} ${styles[theme]}`}
      closable={false}
      footer={null}
      title={null}
      visible={showQuick}
      unmountOnExit={true}
      onCancel={handleCancel}
      width={480}>
      <div className={styles['top']}>
        <BorderBtn
          iconLeft={<IconEdit />}
          width={88}
          height={40}
          gradient={true}
          text={'编辑'}
          onClick={goDetail}
        />
        <div className={styles['close']} onClick={handleCancel}>
          {' '}
          <IconClosure />
        </div>
      </div>
      <div className={`${styles['content']} `} id={'reactMarkDown'}>
        <div className={styles['title']}>{detailData.title}</div>
        <div className={styles['date']}>
          最近修改时间：{detailData.gmtModifyDate || detailData.gmtModified}
        </div>
        <div className={styles['tags']}>
          {tagsList?.map((tag, index) => (
            <span key={index}>#{tag.tagName}</span>
          ))}
        </div>
        <Markdown content={detailData.content}></Markdown>
      </div>
    </Drawer>
  )
}

export default ShowQuickDrawer
